import { render } from "./DisplayResultOptions.vue?vue&type=template&id=0746ba62&scoped=true"
import script from "./DisplayResultOptions.vue?vue&type=script&lang=js"
export * from "./DisplayResultOptions.vue?vue&type=script&lang=js"

import "./DisplayResultOptions.vue?vue&type=style&index=0&id=0746ba62&scoped=true&lang=scss"
/* hot reload */
if (module.hot) {
  script.__hmrId = "0746ba62"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0746ba62', script)) {
    api.reload('0746ba62', script)
  }
  
  module.hot.accept("./DisplayResultOptions.vue?vue&type=template&id=0746ba62&scoped=true", () => {
    api.rerender('0746ba62', render)
  })

}


import exportComponent from "/data/tfs-agent-build-2/agent/_work/2/s/30-Frontend/Frontend/app/node_modules/vue-loader/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0746ba62"],['__file',"src/components/DisplayResultOptions.vue"]])